/* ============================================================
   CATCHY — Core JavaScript v2
   ============================================================ */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

  function debounce(fn, ms = 300) {
    let t;
    return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
  }

  /* ---- Backdrop ---- */
  const backdrop = $('#overlay-backdrop');
  const showBackdrop = () => backdrop && backdrop.classList.add('is-visible');
  const hideBackdrop = () => backdrop && backdrop.classList.remove('is-visible');
  on(backdrop, 'click', closeAll);

  function closeAll() {
    closeCart(); closeSearch(); closeMobileMenu(); hideBackdrop();
  }

  /* ---- Header scroll: transparent at top, hide on down, show on up ---- */
  const header = $('#site-header');
  let lastScrollY = window.scrollY;
  let ticking = false;

  var isHomePage = document.body.classList.contains('template-index');

  function updateHeader() {
    const currentY = window.scrollY;
    const barThreshold = 10;
    const headerThreshold = window.innerHeight * 0.45;
    const bar = document.querySelector('.announcement-bar');

    if (!isHomePage) {
      // Non-home pages: starts visible, hides on scroll down, shows on scroll up
      if (bar) bar.style.transform = currentY > barThreshold ? 'translateY(-100%)' : 'translateY(0)';
      if (header) {
        header.classList.add('header--scrolled');
        if (currentY > lastScrollY && currentY > 60) {
          header.classList.add('header--hidden');
        } else {
          header.classList.remove('header--hidden');
        }
      }
      lastScrollY = currentY;
      ticking = false;
      return;
    }

    // Home page logic
    if (bar) bar.style.transform = currentY > barThreshold ? 'translateY(-100%)' : 'translateY(0)';

    if (header) {
      if (currentY <= barThreshold) {
        header.classList.remove('header--scrolled', 'header--hidden');
      } else if (currentY <= headerThreshold) {
        header.classList.remove('header--scrolled', 'header--hidden');
      } else if (currentY > lastScrollY) {
        header.classList.add('header--scrolled', 'header--hidden');
      } else {
        header.classList.add('header--scrolled');
        header.classList.remove('header--hidden');
      }
    }

    lastScrollY = currentY;
    ticking = false;
  }

  on(window, 'scroll', () => {
    if (!ticking) {
      requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });

  // Run once on load
  updateHeader();

  /* ---- Money format ---- */
  function moneyFormat(cents) {
    return 'EGP ' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---- Cart count ---- */
  function updateCartCount(n) {
    $$('#cart-count, #mobile-cart-count').forEach(el => {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  /* ---- Fetch cart ---- */
  async function fetchCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  /* ---- Render cart drawer ---- */
  async function renderCart() {
    const itemsEl = $('#cart-drawer-items');
    const footerEl = $('#cart-drawer-footer');
    const subtotalEl = $('#cart-drawer-subtotal');
    const countEl = $('#cart-drawer-count');
    if (!itemsEl) return;

    const cart = await fetchCart();
    updateCartCount(cart.item_count);
    if (countEl) countEl.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';

    if (!cart.item_count) {
      itemsEl.innerHTML = `<div class="cart-drawer__empty">
        <svg class="cart-drawer__empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
        <p style="font-size:.875rem;font-weight:300;margin-bottom:1.5rem;">Your cart is empty</p>
        <a href="/collections/all" class="btn btn--outline">Explore Collection</a>
      </div>`;
      footerEl && (footerEl.style.display = 'none');
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => {
      const img = item.image ? item.image.replace(/(\.\w+)$/, '_120x$1') : '';
      return `<div class="cart-line-item" data-key="${item.key}">
        <a href="${item.url}"><img src="${img}" alt="${item.title}" class="cart-line-item__img" loading="lazy"></a>
        <div class="cart-line-item__info">
          <a href="${item.url}" class="cart-line-item__name">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-line-item__variant">${item.variant_title}</p>` : ''}
          <div class="cart-line-item__qty">
            <button class="cart-line-item__qty-btn" data-action="decrease" data-key="${item.key}">−</button>
            <span class="cart-line-item__qty-count">${item.quantity}</span>
            <button class="cart-line-item__qty-btn" data-action="increase" data-key="${item.key}">+</button>
          </div>
          <div style="display:flex;justify-content:space-between;margin-top:.5rem;align-items:center;">
            <span class="cart-line-item__price">${moneyFormat(item.final_line_price)}</span>
            <button class="cart-line-item__remove" data-action="remove" data-key="${item.key}">Remove</button>
          </div>
        </div>
      </div>`;
    }).join('');

    if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
    footerEl && (footerEl.style.display = 'block');

    // Free shipping bar
    const threshold = 300000;
    const existing = $('#shipping-progress-bar');
    if (cart.total_price < threshold) {
      const rem = ((threshold - cart.total_price) / 100).toFixed(0);
      const pct = Math.round(cart.total_price / threshold * 100);
      const html = `<div id="shipping-progress-bar" style="margin-bottom:1rem;">
        <p style="font-size:.75rem;color:var(--c-dark-gray);margin-bottom:.5rem;font-weight:300;">Add <strong>EGP ${rem}</strong> for free shipping</p>
        <div style="height:3px;background:var(--c-light-gray);border-radius:2px;overflow:hidden;">
          <div style="height:100%;width:${pct}%;background:var(--c-gold);transition:width .5s;border-radius:2px;"></div>
        </div>
      </div>`;
      if (existing) existing.outerHTML = html;
      else footerEl && footerEl.insertAdjacentHTML('afterbegin', html);
    } else {
      existing && existing.remove();
      const note = footerEl && footerEl.querySelector('.cart-drawer__shipping-note');
      if (note) note.textContent = '🎉 Free shipping unlocked!';
    }

    // Qty/remove handlers
    $$('[data-action]', itemsEl).forEach(btn => {
      on(btn, 'click', async () => {
        const key = btn.dataset.key;
        const action = btn.dataset.action;
        const item = cart.items.find(i => i.key === key);
        if (!item) return;
        const qty = action === 'increase' ? item.quantity + 1 : action === 'decrease' ? item.quantity - 1 : 0;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        renderCart();
      });
    });
  }

  /* ---- Cart add ---- */
  async function cartAdd(variantId, qty = 1, props = {}) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: qty, properties: props })
    });
    const data = await res.json();
    if (data.status) throw new Error(data.description);
    openCart();
    return data;
  }

  /* ---- Cart open/close ---- */
  const cartDrawer = $('#cart-drawer');
  function openCart() {
    cartDrawer && cartDrawer.classList.add('is-open');
    cartDrawer && cartDrawer.setAttribute('aria-hidden', 'false');
    showBackdrop();
    document.body.style.overflow = 'hidden';
    renderCart();
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('is-open');
    cartDrawer && cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  on($('#header-cart-btn'), 'click', openCart);
  on($('#mobile-cart-btn'), 'click', openCart);
  on($('#cart-drawer-close'), 'click', () => { closeCart(); hideBackdrop(); });

  /* ---- ATC form submit ---- */
  on(document, 'submit', async e => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const vid = form.querySelector('[name="id"]');
    if (!vid) return;
    const orig = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
    try { await cartAdd(vid.value); }
    catch (err) { alert(err.message || 'Could not add to cart.'); }
    finally { if (btn) { btn.textContent = orig; btn.disabled = false; } }
  });

  /* ---- Search ---- */
  const searchDrawer = $('#search-drawer');
  const searchInput = $('#search-drawer-input');
  function openSearch() {
    searchDrawer && searchDrawer.classList.add('is-open');
    showBackdrop();
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput && searchInput.focus(), 80);
  }
  function closeSearch() {
    searchDrawer && searchDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  on($('#header-search-btn'), 'click', openSearch);
  on($('#mobile-search-btn'), 'click', openSearch);
  on($('#search-drawer-close'), 'click', () => { closeSearch(); hideBackdrop(); });

  /* ---- Mobile Menu ---- */
  const mobileMenu = $('#mobile-menu');
  function openMobileMenu() {
    mobileMenu && mobileMenu.classList.add('is-open');
    mobileMenu && mobileMenu.setAttribute('aria-hidden', 'false');
    showBackdrop();
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mobileMenu && mobileMenu.classList.remove('is-open');
    mobileMenu && mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  on($('#mobile-menu-btn'), 'click', openMobileMenu);
  on($('#mobile-menu-close'), 'click', () => { closeMobileMenu(); hideBackdrop(); });

  // Mobile accordion
  $$('[data-mobile-accordion]').forEach(btn => {
    on(btn, 'click', () => {
      const sub = btn.nextElementSibling;
      const open = sub && sub.classList.contains('is-open');
      $$('.mobile-sub-nav.is-open').forEach(el => el.classList.remove('is-open'));
      $$('[data-mobile-accordion] svg').forEach(svg => svg.style.transform = '');
      if (!open && sub) {
        sub.classList.add('is-open');
        const svg = btn.querySelector('svg');
        if (svg) svg.style.transform = 'rotate(180deg)';
      }
    });
  });

  /* ---- Category Tabs ---- */
  $$('.category-tab-btn').forEach(btn => {
    on(btn, 'click', () => {
      $$('.category-tab-btn').forEach(b => { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
      $$('.category-tab-panel').forEach(p => p.classList.remove('is-active'));
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');
      const panel = $('#tab-panel-' + btn.dataset.tab);
      if (panel) panel.classList.add('is-active');
    });
  });

  /* ---- Video Carousel ---- */
  const vTrack = $('#video-carousel-track');
  if (vTrack) {
    let vIdx = 0;
    const vItems = $$('.video-carousel-item', vTrack);
    const perView = window.innerWidth <= 768 ? 1 : 3;
    const move = () => { vTrack.style.transform = `translateX(-${vIdx * (100 / perView)}%)`; };
    on($('#video-next'), 'click', () => { vIdx = Math.min(vIdx + 1, vItems.length - perView); move(); });
    on($('#video-prev'), 'click', () => { vIdx = Math.max(vIdx - 1, 0); move(); });
  }

  /* ---- Scroll animations ---- */
  const animObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); animObs.unobserve(e.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  function observeAll() {
    $$('.fade-up,.fade-in,.slide-in-left,.slide-in-right,.stagger-children,.brand-statement__line,.brand-statement__copy').forEach(el => animObs.observe(el));
  }
  observeAll();

  /* ---- Quick view trigger ---- */
  on(document, 'click', e => {
    const btn = e.target.closest('[data-quick-view]');
    if (btn && window.CATCHY.openQuickView) window.CATCHY.openQuickView(btn.dataset.quickView);
  });

  /* ---- ESC key ---- */
  on(document, 'keydown', e => { if (e.key === 'Escape') closeAll(); });

  /* ---- Init ---- */
  fetchCart().then(c => updateCartCount(c.item_count)).catch(() => {});

  /* ---- Expose globals ---- */
  window.CATCHY = window.CATCHY || {};
  Object.assign(window.CATCHY, {
    cartAdd, renderCart, openCart, closeCart,
    openSearch, closeSearch, reobserve: observeAll
  });

})();




/* ---- Color Swatch Swap ---- */
function pcSwap(btn){
  var img = btn.dataset.img;
  if(!img) return;
  var card = btn.closest('.product-card');
  if(!card) return;
  var main = card.querySelector('.pci-main');
  if(!main) return;
  // Active state
  card.querySelectorAll('.pc-swatch').forEach(function(s){ s.classList.remove('is-active'); });
  btn.classList.add('is-active');
  // Swap
  main.style.opacity = '0';
  main.src = img;
  main.onload = function(){ main.style.opacity = '1'; };
  main.style.transition = 'opacity 0.2s';
}


/* ── Fly to Cart Animation ── */
(function () {
  function easeInOutCubic(t) {
    return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t+2,3)/2;
  }

  function flyToCart(btn) {
    var imgEl   = btn.closest('.product-card, .col-card, .pm-form, .pm-info')
                    && (btn.closest('.product-card, .col-card') || document.querySelector('.pm-gallery'));
    var cartEl  = document.querySelector('#cart-icon, .cart-count-bubble, [data-cart-toggle], .nav-cart, #cart-toggle, .header__icon--cart');
    if (!cartEl) return;

    /* find image near the button */
    var card = btn.closest('.product-card, .col-card, .pm-info, form[action="/cart/add"]');
    var img  = card
      ? (card.closest('.product-card, .col-card')
          ? card.closest('.product-card, .col-card').querySelector('img')
          : document.querySelector('.pm-gallery img, .pm-gallery .pm-main-img'))
      : null;

    if (!img) img = document.querySelector('.pm-gallery img') || btn;

    var srcRect  = img.getBoundingClientRect();
    var destRect = cartEl.getBoundingClientRect();
    var size = 52;

    var startX = srcRect.left  + srcRect.width/2  - size/2;
    var startY = srcRect.top   + srcRect.height/2 - size/2;
    var endX   = destRect.left + destRect.width/2  - size/2;
    var endY   = destRect.top  + destRect.height/2 - size/2;

    /* clone image or create emoji dot */
    var fly = document.createElement('div');
    fly.style.cssText = [
      'position:fixed',
      'z-index:9999',
      'pointer-events:none',
      'width:' + size + 'px',
      'height:' + size + 'px',
      'left:' + startX + 'px',
      'top:' + startY + 'px',
      'border-radius:50%',
      'overflow:hidden',
      'background:#fff',
      'border:1px solid rgba(0,0,0,.1)',
      'box-shadow:0 8px 24px rgba(0,0,0,.15)',
      'display:flex',
      'align-items:center',
      'justify-content:center'
    ].join(';');

    var flyImg = document.createElement('img');
    flyImg.src = img.src || img.currentSrc || '';
    flyImg.style.cssText = 'width:100%;height:100%;object-fit:cover;';
    fly.appendChild(flyImg);
    document.body.appendChild(fly);

    var startTime = null;
    var duration  = 680;

    function step(ts) {
      if (!startTime) startTime = ts;
      var p    = Math.min((ts - startTime) / duration, 1);
      var ease = easeInOutCubic(p);
      var cx   = startX + (endX - startX) * ease;
      var cy   = startY + (endY - startY) * ease - 110 * Math.sin(Math.PI * p);
      var sc   = 1 - ease * 0.7;
      var op   = p > 0.8 ? (1 - p) / 0.2 : 1;

      fly.style.left      = cx + 'px';
      fly.style.top       = cy + 'px';
      fly.style.transform = 'scale(' + sc + ')';
      fly.style.opacity   = op;

      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        if (fly.parentNode) fly.parentNode.removeChild(fly);
        /* bump cart count */
        var badge = document.querySelector('.cart-count, #cart-count, .cart-item-count, [data-cart-count]');
        if (badge) {
          var n = parseInt(badge.textContent || '0', 10) + 1;
          badge.textContent = n;
          badge.style.transform = 'scale(1.6)';
          badge.style.transition = 'transform 0.3s cubic-bezier(0.22,1,0.36,1)';
          setTimeout(function(){ badge.style.transform = ''; }, 350);
        }
      }
    }
    requestAnimationFrame(step);
  }

  /* Attach to ATC buttons — now and on future mutations */
  function attachFly() {
    document.querySelectorAll('[data-atc-fly]').forEach(function(btn) {
      if (btn._flyAttached) return;
      btn._flyAttached = true;
      btn.addEventListener('click', function() { flyToCart(btn); });
    });
  }

  document.addEventListener('DOMContentLoaded', attachFly);
  var obs = new MutationObserver(attachFly);
  obs.observe(document.body, { childList: true, subtree: true });
})();


